exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".obligatoria[data-v-317a698a]{background-color:red;color:#fff}.bg-primary[data-v-317a698a]{background-color:#1ab394;border-color:#1ab394;color:#fff}", ""]);

// exports
